import React from 'react';
import { TbMenu2, TbMenuDeep, TbPlus } from 'react-icons/tb';
import { Link } from 'react-router-dom';

import LogoPrimary from '@/assets/images/black-for-restaurants.webp';

import { Typography } from '@/components/atoms/Typography';

import { NavbarSubMenuItem } from './NavbarSubMenuItem';

type NavbarLink = {
  label: string;
  href: string;
};

interface NavbarProps {
  links?: NavbarLink[];
  onMenuClick?: () => void;
  hideSidebar?: boolean;
}

export const Navbar: React.FC<NavbarProps> = ({ links, onMenuClick, hideSidebar }) => {
  return (
    <nav className="flex w-screen h-20 items-center justify-between bg-hero-patterns px-5 md:px-10 sticky top-0 z-10 bg-primary">
      <div className="flex items-center  gap-5 w-full">
        {onMenuClick && !hideSidebar && (
          <button className="sm:hidden" onClick={() => onMenuClick()}>
            {hideSidebar ? (
              <TbMenuDeep className="w-7 h-7 text-white cursor-pointer relative rotate-180" />
            ) : (
              <TbMenu2 className="w-7 h-7 text-white cursor-pointer relative" />
            )}
          </button>
        )}
        <Link to="/" className="text-xl font-bold flex gap-10 text-transparent md:text-white items-center">
          <img height={50} width={50} src={LogoPrimary} alt="logo of mrh" className="w-44 h-full object-cover" />
        </Link>

        <Link
          to="/proposal-restaurant"
          className="mt-1.5 hidden md:flex items-center gap-1 border w-fit rounded-full pl-2 md:pr-3 pr-2 py-1 hover:bg-gray-100/20 duration-300 ease-in-out"
        >
          <TbPlus className="text-white" />

          <Typography variant="h4" color="white">
            Ajouter un restaurant
          </Typography>
        </Link>

        {links && (
          <div>
            {links?.map((link) => (
              <Link to={link.href} className="mr-4">
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
      <div className="hidden md:flex flex-row w-full  justify-end">
        <NavbarSubMenuItem />
      </div>
    </nav>
  );
};
